<vpfa-mobile-page-title [title]="'copyright.title' | translate"></vpfa-mobile-page-title>
<p [innerHTML]="'copyright.content' | translate"></p>
<div class="actions">
  <a (click)="onClose()">
    <vpfa-action-button [outline]="true" [border]="false">
      {{ 'common.close' | translate }}
    </vpfa-action-button>
  </a>
</div>
